"use client";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const d = (t) => /* @__PURE__ */ e(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "#fff",
          d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
        }
      ),
      /* @__PURE__ */ o("path", { fill: "currentColor", d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0" }),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
          clipRule: "evenodd"
        }
      )
    ]
  }
), c = l(d);
export {
  c as RadioButtonChecked,
  c as default
};
